import React, { Fragment } from 'react';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

const LogicJump = (props) => {
    const { action, logicIdx, idx, field, fields, thankyou_screens, welcome_screens, setChoice, setYesNo, setOp, setJumpTo, handleDelete, setErrorMessage, addAlwaysJump } = props;

    function getChoiceIndex(ref) {
        if (!ref) return '';
        return field.properties.choices.findIndex(choice => choice.ref === ref);
    }

    function handleSetChoice(value) {
        if (value || value === 0) {
            if (setErrorMessage) setErrorMessage(null);
            setChoice(value, field, logicIdx, idx);
        }
    }

    function handleSetJump(value) {
        if (idx || idx === 0) {
            setJumpTo(value, logicIdx, idx);
        } else {
            addAlwaysJump(value, logicIdx);
        }
    }

    function handleDeleteJump() {
        if (setErrorMessage) setErrorMessage(null);
        handleDelete(logicIdx, idx);
    }

    return (
        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', margin: 5 }}>
            {(field.type === 'multiple_choice' && action.condition.vars[1]) &&
                <Fragment>
                    <p>{`If answer`}</p>
                    <select value={action.condition.op} onChange={(e) => setOp(e.target.value, logicIdx, idx)}>
                        {choice_operators.map(op => (
                            <option key={op.value} value={op.value}>{op.label}</option>
                        ))}
                    </select>
                    <select value={getChoiceIndex(action.condition.vars[1].value)} onChange={(e) => handleSetChoice(e.target.value)}>
                        {!action.condition.vars[1].value &&
                            <option value={''}>-------</option>
                        }
                        {field.properties.choices.map((option, choiceIdx) => (
                            <option key={choiceIdx} value={choiceIdx}>{option.label}</option>
                        ))}
                    </select>
                </Fragment>
            }
            {(field.type === 'yes_no' && action.condition.vars[1]) &&
                <Fragment>
                    <p>{`If answer`}</p>
                    <select value={action.condition.op} onChange={(e) => setOp(e.target.value, logicIdx, idx)}>
                        {choice_operators.map(op => (
                            <option key={op.value} value={op.value}>{op.label}</option>
                        ))}
                    </select>
                    <select value={action.condition.vars[1].value} onChange={(e) => setYesNo(trueOrFalse(e.target.value), logicIdx, idx)}>
                        <option value={true}>Yes</option>
                        <option value={false}>No</option>
                    </select>
                </Fragment>
            }
            {action.condition.op === 'always' &&
                <p>In all other cases</p>
            }
            <p>{`jump to ref: `}</p>
            <select value={action.details.to.value} onChange={(e) => handleSetJump(e.target.value)}>
                {(!idx && idx !== 0) &&
                    <option value={""}> ---------- </option>
                }
                {welcome_screens &&
                    welcome_screens.map(ws => (
                        <option key={ws.ref} value={ws.ref}> {`WS. ${ws.ref}`} </option>
                    ))
                }
                {fields &&
                    fields.map((f, idx) => (
                        <option key={f.ref} value={f.ref}> {`${idx + 1}. ${f.ref}`} </option>
                    ))
                }
                {thankyou_screens &&
                    thankyou_screens.map(tys => (
                        <option key={tys.ref} value={tys.ref}> {`TYS. ${tys.ref}`} </option>
                    ))
                }
            </select>
            {(idx || idx === 0) &&
                <IconButton onClick={handleDeleteJump}>
                    <CloseIcon fontSize="small" />
                </IconButton>
            }
        </div>
    )
};

function trueOrFalse(value) {
    if (value === 'true' || value === true) return true;
    else if (value === 'false' || value === false) return false;
    else return;
}

const choice_operators = [
    { label: 'is', value: 'is' },
    { label: 'is not', value: 'is_not' },
]

// const text_operators = [
//     {label: 'equal', value: 'equal'},
//     {label: 'not_equal', value: 'not_equal'},
//     {label: 'begins_with', value: 'begins_with'},
//     {label: 'ends_with', value: 'ends_with'},
//     {label: 'contains', value: 'contains'},
//     {label: 'not_contains', value: 'not_contains'},
// ]

// const num_operators = [
//     {label: 'equal', value: 'equal'},
//     {label: 'not_equal', value: 'not_equal'},
//     {label: 'lower_than', value: 'lower_than'},
//     {label: 'lower_equal_than', value: 'lower_equal_than'},
//     {label: 'greater_than', value: 'greater_than'},
//     {label: 'greater_equal_than', value: 'greater_equal_than'},
// ]

// const date_operators = [
//     {label: 'on', value: 'on'}
// ]

export default LogicJump;